import {StrictMode} from 'react';
import ReactDOM from 'react-dom';
import 'url-search-params-polyfill';
import {BrowserRouter} from "react-router-dom";

import reportWebVitals from './reportWebVitals';
import App from './app';
import init from "./init";

const isSSR = typeof window.__INITIAL_STATE__ !== 'undefined';
const app = {
    ...init({
        initialState: module.hot?.data?.initialState || window.__INITIAL_STATE__,
        host: window.location.host,
    }),
    isSSR
};
if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_STAGING) {
    window.app = app;
}

function mountApp(element, container) {
    if (isSSR) {
        ReactDOM.hydrate(element, container);
    } else {
        ReactDOM.render(element, container);
    }
}

mountApp(
    <StrictMode>
        <BrowserRouter>
            <App {...app} />
        </BrowserRouter>
    </StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
